export const attachTooltip = "N5a";
export const insertTooltip = "O5a";
export default {attachTooltip,insertTooltip};